import { Icons, type LBIcon } from '@/assets/icons/icons';

import type { Skill } from './plugins-query';

const SKILL_ICONS: Array<[RegExp, LBIcon]> = [
  [/standup/, Icons.attendees],
  [/routine/, Icons.routines],
  [/meeting|prep/, Icons.meetings],
  [/calendar/, Icons.calendar],
  [/mail|inbox|triage/, Icons.inbox],
  [/journal|diary/, Icons.journal],
  [/learn|memor/, Icons.lightbulb],
  [/review|weekly|recap/, Icons.history],
  [/todo|task/, Icons.todoList],
  [/research|web/, Icons.research],
  [/note/, Icons.notepad],
  [/follow|remind|chase/, Icons.notification],
  [/code|debug|deploy/, Icons.code],
];

export function skillIcon(
  skill: Pick<Skill, 'name' | 'description' | 'isSystem'>
): LBIcon {
  const searchText = `${skill.name} ${skill.description}`.toLowerCase();
  return (
    SKILL_ICONS.find(([pattern]) => pattern.test(searchText))?.[1] ??
    (skill.isSystem ? Icons.sparkles : Icons.bookText)
  );
}
